import AboutUs from "../components/AboutUs";

export default function Home() {
  return (
    <>
      <header className="hero">
        <div className="container hero__inner">
          <div className="hero__content">
            <h2>Willkommen bei der Stickerei Zschoche</h2>
            <p className="beschreibung">
              Bestickung - die wohl hochwertigste Möglichkeit der Textilveredelung.<br />
              Ob für Ihre Firma und Ihre Mitarbeiter -  Ihr Vereinslogo als Hingucker  - als Werbeträger oder als Geschenk - Als auch im  privaten Bereich - durch individuelle Gestaltung oder der möglichen Personalisierung wird Ihr Textil zum Hingucker. <br />
              Ihr Wunschmotiv wird anhand Ihrer Vorlage umgesetzt - auch Einzelanfertigungen sind machbar. <br />
              Gerne übernehmen wir die Beschaffung der Textilien – kontaktieren Sie uns jederzeit gerne!
            </p> 
            <p>
              Auch Kleinstserien sind möglich.
            </p>
            <a 
              className="btn" 
              href="mailto:info@stickerei-zschoche.de"
            >
              Kontakt per E-Mail
            </a>
          </div>
          <div className="hero__art" aria-hidden="true">
            <div className="art__card"></div>
            <div className="art__card art__card--offset"></div>
          </div>
        </div>
      </header>

      <AboutUs />
    </>
  );
}
